
import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
  name: "InputText",
  computed: {
    displayValue: {
      get: function() {
        if ((this as any).isInputActive) {
          return (this as any).value.toString();
        } else {
          if ((this as any).value){
              return (this as any).value;
          } else {
            return "";
          }
        }
      },
      set: function(modifiedValue) {
        (this as any).newValue = modifiedValue;
      }
    }
  }
})
export default class InputText extends Vue {
  @Prop([String]) value!: any;
  newValue: any = 0;
  isInputActive: boolean = false;

  emitValue() {
    this.$emit("checkChanges", this.newValue);
  }
}
